// NOTE: NSAI-5334 — the one dedup rule for `onboarding_tour_step_viewed`,
// shared so web (Joyride) and mobile (its own overlay) count step entries the
// same way. Both clients see the step index move for reasons that are not a
// new step on screen: a correction effect re-pointing the index at the same
// target after the steps list is rebuilt, a paused step resuming, the same
// index set twice. The step's target is what the user actually sees, so it is
// the key: a step is captured only when its target differs from the last one
// captured. Going Back and forward again changes the target, so it counts.
// The flip side: two consecutive steps on the same element would count once,
// so every tour step keeps its own target (all of them do today).

export interface IResolveTourStepViewProps {
  isRunning: boolean;
  // NOTE: The target of the step now on screen; `null` when it cannot be read.
  stepKey: string | null;
  lastViewedStepKey: string | null;
}

export interface IResolveTourStepViewResult {
  shouldCapture: boolean;
  // NOTE: What the caller stores for the next call. A stopped tour clears it,
  // so a restarted tour counts its first step again.
  lastViewedStepKey: string | null;
}

export const resolveTourStepView = ({
  isRunning,
  stepKey,
  lastViewedStepKey,
}: IResolveTourStepViewProps): IResolveTourStepViewResult => {
  if (!isRunning) {
    return { shouldCapture: false, lastViewedStepKey: null };
  }

  if (stepKey === null || stepKey === lastViewedStepKey) {
    return { shouldCapture: false, lastViewedStepKey };
  }

  return { shouldCapture: true, lastViewedStepKey: stepKey };
};
